<!-- eslint-disable vue/no-unused-vars -->
<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="container-fluid">
    <Breadcrumbs main="Motion Drive" :path="breadcrumbPath" />

    <!-- Customer selector -->
    <div
      class="row m-0 width-100-p"
      v-if="
        $store.state.auth.user != null &&
        $store.state.auth.user.is_admin &&
        !$store.state.auth.user.is_auditor
      "
    >
      <div
        class="row m-0 py-3 width-100-p bg-me-primary border-color-light rounded-4"
      >
      <el-col :span="24">
                <h5 class="text-white mt-3 ml-1">Upload for a Customer</h5>
                <span class="moderat-white-12 ml-1">
                  * Use the customer selector to select the customer for the upload
                </span>
      </el-col>
  
      <!-- custom filter scenario 1 -->
      <!-- customer filter (admin only) & location filter & MP filter & custom date -->
      <div class="custom-filter-container pr-20">
      <!-- Custom filter -->
      <el-row >
          <div 
            class="custom-filter-container-wrapper d-flex row y-center m-0 mb-12 width-100-p"
            >
                <el-form :label-position="`top`" class="custom-filter-form d-flex">
                <el-space
                    class="custom-filter-space"
                    fill
                    >
                    <el-row gutter="20">
                      <el-col 
                          :span="$vuetify.display.width > 1280 ? 10 : 24" 
                          :class="$vuetify.display.width > 645 ? 'x-start' : 'x-center'" >
                            <el-form-item
                                  class="custom-filter-item label-style"
                                  prop="customer"
                                  label="Customer"
                              >
                                  <!-- customer select -->
                                  <div>
                                    <el-tooltip
                                    effect="light"
                                    placement="top"
                                    show-after="500"
                                    hide-after="300"
                                    >
                                    <template #content >
                                      <span :style="{fontSize: '12px', textAlign: 'left'}"> Upload for this customer</span>
                                    </template>
                                      <el-select
                                          v-model="customerId"
                                          placeholder="Select Customer"
                                          class="custom-filter-select"
                                          clearable
                                          >

                                          <el-option
                                              v-for="item in customerList"
                                              :key="item.id"
                                              :label="item.full_name"
                                              :value="item.id"
                                              >
                                              <span>{{ item.full_name }}</span>
                                              <!-- <span>{{ item.phone }}</span> -->
                                          </el-option>
                                      </el-select>
                                      </el-tooltip>
                                  </div>
                            </el-form-item>
                      </el-col>
                    </el-row>
                </el-space>
                </el-form>
          </div>
      </el-row>
      </div>
    </div>
    </div>

    <div
      v-if="canShowUploadArea"
      class="row px-0 m-0"
      :class="$vuetify.display.width >= 1400 ? 'mt-30' : $vuetify.display.width >= 768 ? 'mt-30' : $vuetify.display.width >= 375 ? 'mt-24' : 'mt-20'"
    >
      <!-- uploader -->
      <el-row class="m-0 mb-3 px-0">
        <el-col
          :span="24"
          class="p-0"
          :class="$vuetify.display.width < 750 ? 'x-center' : ''"
        >
          <el-upload
            ref="upload"
            class="upload-demo width-100-p"
            action="#"
            :limit="1"
            :auto-upload="false"
            drag
            :on-change="onChange"
            :on-remove="onRemove"
          >
            <!-- <i class="fa fa-cloud-upload f-46"></i> -->
            <svg class="stroke-icon width-40 height-35">
              <use
                href="@/assets/svg/icon-sprite.svg#drag-and-drop-icon-cloud"
              ></use>
            </svg>
            <div class="el-upload__text text-white">
              <em>Drop file here</em> or click to upload
            </div>
            <template #tip>
              <div class="el-upload__tip text-white">
                There is a maximum limit of 100MB for the upload process
              </div>
            </template>
          </el-upload>
        </el-col>
      </el-row>
    </div>

    <el-row class="m-0 width-100-p mt-3">
      <el-col class="d-flex align-item-center" :span="24">
        <div class="row m-0 width-100-p">
          <div
            class="row m-0 py-3 width-100-p bg-me-primary border-color-light rounded-4"
          >


            <!-- Filter Section : filter by category, file type -->
            <div class="custom-filter-container pr-20 mb-10">
              <el-row>
                <div
                  class="custom-filter-container-wrapper d-flex row y-center m-0 width-100-p"
                >
                  <el-form :label-position="`top`" class="custom-filter-form d-flex">
                    <el-space class="custom-filter-space" fill>
                      <el-row gutter="20">
                        <el-col
                          :span="$vuetify.display.width > 1280 ? 10 : 24"
                          :class="$vuetify.display.width > 645 ? 'x-start' : 'x-center'"
                        >
                          <el-form-item
                            class="custom-filter-item label-style"
                            prop="category"
                            label="Category"
                          >
                            <el-select
                              v-model="filter.category"
                              placeholder="All categories"
                              class="custom-filter-select"
                              :clearable="
                                !(
                                  $store.state.auth.user != null &&
                                  $store.state.auth.user.is_auditor
                                )
                              "
                              @change="onFilterChange"
                              @clear="onFilterChange"
                            >
                              <el-option
                                v-for="item in availableCategoryOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                              />
                            </el-select>
                          </el-form-item>
                        </el-col>
                        <el-col
                          :span="$vuetify.display.width > 1280 ? 10 : 24"
                          :class="$vuetify.display.width > 645 ? 'x-start' : 'x-center'"
                        >
                          <el-form-item
                            class="custom-filter-item label-style"
                            prop="file_type"
                            label="File type"
                          >
                            <el-select
                              v-model="filter.file_type"
                              placeholder="All file types"
                              class="custom-filter-select"
                              clearable
                              @change="onFilterChange"
                              @clear="onFilterChange"
                            >
                              <el-option
                                v-for="item in fileTypeOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                              />
                            </el-select>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-space>
                  </el-form>
                </div>
              </el-row>
            </div>

            <el-row :gutter="$vuetify.display.width > 1200 ? 10 : 0">
              <!-- search bay -->
              <el-col
                    :span="$vuetify.display.width > 1200 ? 24 : 24"
                    :class="$vuetify.display.width > 1200 ? 'x-start order-1 mb-10' : 'x-start order-3 mb-10'"
                  >
                    <el-input
                      size="large"
                      v-model="filter.search"
                        placeholder="Type to search by filename, customer, or uploaded by"
                        :prefix-icon="Search"
                        class="mixedSearchBar-2"
                        id="mixedSearchBar-input-2"
                        clearable
                        @clear="handleReload"
                    >
                      <template #append>
                        <!-- <el-button :icon="Search" /> -->
                        <el-button
                            @click.stop="handleReload"
                            class="newSearchButtonClass"
                          >
                          <svg v-if="$vuetify.display.width > 800" class="width-115 height-40">
                            <use
                              href="@/assets/svg/newSvgIcon.svg#newSearchButtonIcon"
                            ></use>
                          </svg>
                          <svg v-else class="width-59 height-40" >
                            <use
                              href="@/assets/svg/newSvgIcon.svg#newSearchButtonIcon-small"
                            ></use>
                          </svg>
                        </el-button>
                      </template>
                    </el-input>

              </el-col>

            </el-row>

            <DataTable
              :loadingProp="loading"
              :usersDataProp="fileList"
              :totalRowProp="total_items"
              :tableHeightProp="tableHeight"
              @tableAction="handleTableAction"
            />
          </div>
        </div>
      </el-col>
    </el-row>

  </div>
</template>

<script>
import Breadcrumbs from "../../components/bread_crumbs.vue";
import UserService from "../../services/user.service.js";
import DataTable from "./dataTable.vue";
import { ElMessageBox } from "element-plus";
export default {
  name: "bucketFiles",
  components: {
    Breadcrumbs,
    // Filter,
    DataTable,
  },
  data() {
    return {
      breadcrumbPath: [
        {
          title: "Support",
          disabled: true,
          href: "",
        },
        {
          title: "File Upload",
          disabled: false,
          href: "/file-upload",
          active: true,
        },
      ],

      fileList: [],
      current_page: 1,
      page_size: 50,
      total_items: 100,
      perPageCount: 50,
      loading: false,
      current_row_index: null,
      filterOpen: false,
      filter: {
        search: "",
        category: null,
        file_type: null,
      },
      categoryOptions: [
        { value: "sessions", label: "Sessions" },
        { value: "unallocated-sessions", label: "Unallocated sessions" },
        { value: "sessions-with-abatement", label: "Sessions with abatement" },
        { value: "charger-logs", label: "Charger logs" },
        { value: "auditor", label: "Auditor" },
        { value: "other", label: "Other" },
      ],
      fileTypeOptions: [
        { value: "txt", label: "TXT" },
        { value: "csv", label: "CSV" },
        { value: "xls", label: "XLS" },
        { value: "xlsx", label: "XLSX" },
        { value: "doc", label: "DOC" },
        { value: "docx", label: "DOCX" },
        { value: "pdf", label: "PDF" },
        { value: "md", label: "MD" },
        { value: "markdown", label: "Markdown" },
      ],
      selectedFile: "",
      selectedFileName: "",

      customerList: [],
      customerId: null,
    };
  },
  computed: {
    canShowUploadArea() {
      const user = this.$store.state.auth.user;
      if (!user || user.is_auditor) {
        return false;
      }
      if (user.is_admin) {
        return this.customerId != null && this.customerId !== "";
      }
      return true;
    },
    tableHeight() {
      return this.canShowUploadArea ? 300 : 450;
    },
    availableCategoryOptions() {
      const user = this.$store.state.auth.user;
      if (user != null && user.is_auditor) {
        return this.categoryOptions.filter(
          (item) =>
            item.value == "sessions-with-abatement" || item.value == "auditor"
        );
      }
      if (user != null && user.is_admin) {
        return this.categoryOptions;
      }
      return this.categoryOptions.filter((item) => item.value != "auditor");
    },
    filterFileList() {
      return this.fileList;
    },
  },
  mounted() {
    if (
      this.$store.state.auth.user != null &&
      this.$store.state.auth.user.is_auditor
    ) {
      this.filter.category = "sessions-with-abatement";
    }

    this.fetchBucketFiles(this.current_page);

    if (
      this.$store.state.auth.user != null &&
      this.$store.state.auth.user.is_admin &&
      !this.$store.state.auth.user.is_auditor
    ) {
      this.fetchCustomerList();
    }
  },
  methods: {
    // Fetch customer data for admin users
    async fetchCustomerList() {
      this.loading = true;
      await UserService.getCustomers(null)
        .then(
          (response) => {
            if (!response || !response.data || !response.data.customers) {
              this.customers = [];
            } else {
              this.customerList = response.data.customers;
            }
          },
          (error) => {
            this.loading = false;
            console.log(error.message);
            if (error.response && error.response.status == 401) {
              this.$router.push({
                path: "/",
              });
            }
          }
        )
        .catch((error) => {
          this.loading = false;
          console.log(error.message);
          if (error.response && error.response.status == 401) {
            this.$router.push({
              path: "/",
            });
          }
        })
        .finally(() => (this.loading = false));
    },
    onChange(event, fileList) {
      this.loading = true;
      const file = event.raw ? event.raw : null;
      this.fileUpload = file;
      if (file.size / 1024 / 1024 > 100) {
        this.loading = false;
        this.$message.error(`file can not be greater than 100MB!`);
        fileList.pop();
      } else if (file) {
        this.selectedFile = event.raw;
        this.selectedFileName = event.name;
        this.uploadFile();
        fileList.pop();
      }
    },

    uploadFile () {
      UserService.uploadBucketFile(this.selectedFile, this.customerId)
        .then(() => {
          this.loading = false;
          this.selectedFile = "";
          this.selectedFileName = "";
          this.fetchBucketFiles(this.current_page);
        });
    },

    buildBucketFileFilter() {
      const params = {};
      if (
        this.$store.state.auth.user != null &&
        this.$store.state.auth.user.is_auditor
      ) {
        params.category = this.filter.category || "sessions-with-abatement";
      } else if (this.filter.category) {
        params.category = this.filter.category;
      }
      if (this.filter.search) {
        params.search = this.filter.search;
      }
      if (this.filter.file_type) {
        params.file_type = this.filter.file_type;
      }
      return params;
    },

    onFilterChange() {
      this.handleReload();
    },

    fetchBucketFiles(page) {
      this.loading = true;
      UserService.getBucketFiles(page, this.buildBucketFileFilter(), this.perPageCount)
        .then(
          (response) => {
            this.fileList = response.data.results;
            this.total_items = response.data.count;
          },
          (error) => {
            this.loading = false;
            console.log(error);
            if (error.response && error.response.status == 401) {
              this.$router.push({
                path: "/",
              });
            } else if (error.response && error.response.data) {
              const message =
                error.response.data.category ||
                error.response.data.file_type ||
                error.response.data.detail ||
                "Failed to load files.";
              this.$message.error(
                Array.isArray(message) ? message[0] : message
              );
            }
          }
        )
        .catch((error) => {
          this.loading = false;
          console.log(error);
          if (error.response && error.response.status == 401) {
            this.$router.push({
              path: "/",
            });
          }
        })
        .finally(() => (this.loading = false));
    },

    reset_filter11(event) {
      this.current_page = 1;
      this.search = "";
      this.filter = event.filter;
      this.fetchBucketFiles(this.current_page);
    },

    handleTableAction(event) {
      if (event.kind == "delete") {
        this.deleteRow(event.data);
      } else if (event.kind == "changePage") {
        this.current_page = event.index;
        this.fetchBucketFiles(this.current_page);
      } else if (event.kind == "perPageChange") {
        this.current_page = 1;
        this.perPageCount = event.index;
        this.handleReload();
      } else if (event.kind == "bulkDelete") {
        this.bulkDeleteFiles(event.data);
      }
    },

    deleteRow(row) {
      if (!row || !row.id) {
        this.$message.error("File record not found.");
        return;
      }

      ElMessageBox.confirm(
        "Are you sure delete this file?",
        "Confirm Delete",
        {
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          type: "warning",
        }
      )
        .then(() => {
          this.loading = true;
          return UserService.bucketFileBulkDelete({ ids: [row.id] });
        })
        .then(() => {
          this.$message.success("The file has been deleted successfully.");
          this.fetchBucketFiles(this.current_page);
        })
        .catch((error) => {
          if (error == "cancel") {
            return;
          }
          this.loading = false;
          console.log(error);
          if (error.response && error.response.status == 401) {
            this.$router.push({
              path: "/",
            });
          } else {
            this.$message.error("Delete failed.");
          }
        });
    },

    bulkDeleteFiles(rows) {
      const ids = rows.map((row) => row.id);
      if (ids.length == 0) {
        this.$message.error("Please select at least one file to delete.");
        return;
      }

      ElMessageBox.confirm(
        `Are you sure delete ${ids.length} selected file(s)?`,
        "Confirm Bulk Delete",
        {
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          type: "warning",
        }
      )
        .then(() => {
          this.loading = true;
          return UserService.bucketFileBulkDelete({ ids });
        })
        .then(() => {
          this.$message.success("The selected files have been deleted successfully.");
          this.fetchBucketFiles(this.current_page);
        })
        .catch((error) => {
          if (error == "cancel") {
            return;
          }
          this.loading = false;
          console.log(error);
          if (error.response && error.response.status == 401) {
            this.$router.push({
              path: "/",
            });
          } else {
            this.$message.error("Bulk delete failed.");
          }
        });
    },

    handleReload() {
      this.current_page = 1;
      this.fetchBucketFiles(this.current_page);
    },
  },
};
</script>

<style>
.el-table .warning-row {
  --el-table-tr-bg-color: var(--el-color-warning-light-8);
}
.el-table .error-row {
  --el-table-tr-bg-color: var(--el-color-error-light-8);
}

.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}

.cell {
  text-align: center !important;
}

.starter-main .card-body ul {
  list-style-type: none !important;
}

.el-pager {
  -webkit-user-select: none !important;
  user-select: none !important;
  list-style: none !important;
  font-size: 0 !important;
  padding: 0 !important;
  margin: 0 !important;
  display: flex !important;
  align-items: center !important;
  position: relative !important;
  top: 0 !important;
  right: 0 !important;
}

.el-upload-list {
  margin: 10px 0 0 !important;
  padding: 0 !important;
  list-style: none !important;
  position: relative !important;
}
</style>
